/**
 * Flat-fee strings (flat fees and their milestones).
 *
 * Shared by the flat-fee and flat-fee-milestone editors. Help text (h_) was
 * migrated from the inline renderHelpLabel JSX in src/Case/FlatFee/FlatFeeCard.tsx
 * and src/Case/FlatFee/FlatFeeMilestoneCard.tsx — verify against the implementation.
 */
export default {
    d_name: 'Name',
    h_name: 'Brief name for the service covered',

    d_description: 'Description',
    h_description: 'What services does this fee cover, specifically?',

    d_amount: 'Amount',
    h_amount: 'The total cost of all services covered by this fee. No matter how many hours of work are done, this total earned fee will never be higher than this amount.',

    d_isDefault: 'Is Default?',
    h_isDefault: 'If this case is wholly flat fee, then setting this fee to default will tell all new billable tasks to use this flat fee by default.',

    d_earned: 'Earned?',
    h_earned: 'If this amount is now considered earned, check here. This will mark the portion as earned on invoices.',

    d_milestones: 'Milestones',
    h_milestones: '<div>Flat fees can be earned in stages. For example, a will may earn 80% once the documents are prepared, and another 20% when the client signs the documents. We could then create two milestones:<ul><li>Doc Prep</li><li>Client Signing</li></ul>If the total value of the will is $1000, we would assign $800 to Doc Prep and $200 to Client Signing. By checking "earned" on a milestone, that amount will be available for billing when invoicing.</div>',
};
